import { FormattedMessage } from 'react-intl';

import { IUserWalletReward } from '@share/common-types';

import './style.scss';

interface IProps {
  wallet: IUserWalletReward | null | undefined;
}

export function RewardsProgressBar(props: IProps) {
  const { wallet } = props;
  const accumulated = Number(wallet?.accumulatedProgress ?? 0);
  const threshold = Number(wallet?.threshold ?? 0);

  if (threshold <= 0) return null;

  const progress = Math.min(100, (accumulated / threshold) * 100);

  return (
    <div className="rewards-progress-bar">
      <p className="rewards-progress-bar__headline">
        <FormattedMessage id="rewards.progress.headline" />
      </p>
      <div className="rewards-progress-bar__track">
        <div
          className="rewards-progress-bar__fill"
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="rewards-progress-bar__label">
        <FormattedMessage
          id="rewards.progress.label"
          values={{
            current: Math.floor(accumulated),
            target: Math.floor(threshold),
          }}
        />
      </p>
    </div>
  );
}
